import { render, staticRenderFns } from "./OwnerEmailNotificationFormBookingConfirmation.vue?vue&type=template&id=9f157d12&"
import script from "./OwnerEmailNotificationFormBookingConfirmation.vue?vue&type=script&lang=js&"
export * from "./OwnerEmailNotificationFormBookingConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports